import { IRootState } from '@/redux/types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IFilter } from '../../models/sliders'
import { getFilteredSliders } from '@/redux/actions/sliders'

function useFiltersState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { reload } = useSelector((state: IRootState) => state.slider)
  const { globalFamilyId, globalBrandId, globalLineId, globalCountriesId } = useSelector((state: IRootState) => state.global)

  const [filters, setFilters] = useState<IFilter>({
    id: 1,
    family_id: null,
    category_id: null,
    brand_id: null,
    line_id: null,
    countries: [],
    internaltype: 1,
    position: 1,
    modal_title: t('slider')
  })

  const status = [
    { id: 0, name: 'Activo' },
    { id: 1, name: 'Inactivo' }
  ]
  const visibility = [
    { id: 0, name: t('close') },
    { id: 1, name: 'VIP' },
    { id: 2, name: 'Pago' }
  ]
  const optionsData = [
    { data: status, code: 'status', column: 'status' },
    { data: visibility, code: 'visibility', column: 'visibility' }
  ]

  useEffect(() => {
    if (reload) {
      dispatch(
        getFilteredSliders({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          line_id: globalLineId,
          countries: globalCountriesId,
          internaltype: filters.internaltype,
          position: filters.position
        })
      )
    }
  }, [reload])

  useEffect(() => {
    setFilters({
      ...filters,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      countries: globalCountriesId
    })
  }, [globalFamilyId, globalBrandId, globalLineId, globalCountriesId])

  useEffect(() => {
    if (filters.countries.length > 0) {
      dispatch(
        getFilteredSliders({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          line_id: globalLineId,
          countries: globalCountriesId,
          internaltype: filters.internaltype,
          position: filters.position
        })
      )
    }
  }, [filters])

  const handleChangeFilter = (id: number, internaltype: number, position: number | null, title: string) => {
    setFilters({ ...filters, id, internaltype, position, modal_title: title })
  }

  const handleClickSetOptions = (options: any) => {
    dispatch(
      getFilteredSliders({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        line_id: globalLineId,
        countries: globalCountriesId,
        internaltype: filters.internaltype,
        position: filters.position,
        filterBy: options
      })
    )
  }

  return { handleChangeFilter, handleClickSetOptions, filters, optionsData }
}

export default useFiltersState
